<template>
    <div class="position-relative">
        <div class="step-card d-flex flex-column">
          <div class="step-card-header d-flex flex-row align-items-center">
                <span class="step-card-number">3</span>
                <div>
                    <h3 class="mt-5">{{ $t('participantGui.header') }}</h3>
                    <p v-html="$t('participantGui.description')"></p>
                </div>
          </div>
            <div class="d-flex flex-wrap flex-lg-nowrap">
                <bus-device-card :device="device" class="" :key="device.id" v-for="device in busDevices" :isRemovable="true" :isChangeable="true" @saveDevice="saveDevice" @onRemove="isChanged" />
                <bus-device-card-new  class="" @onChange="newCardAdded" />
            </div>
            <div  v-if="majorDeviceItems.length > 0">
                <h5>{{$t('participantGui.additionalNecessaryProducts')}}</h5>
                <div class="d-flex">
                    <bus-device-card :device="device" class="deviceElement-additional" :key="'major'+device.id" v-for="device in majorDeviceItems" :isRemovable="false"  @saveDevice="saveMajorDevice"  :isChangeable="false" />
                </div>
            </div>  
        </div>
</div>
</template>

<script>
import BusDeviceCard from './BusDeviceCard'
import BusDeviceCardNew from './BusDeviceCardNew'
import {mapGetters} from 'vuex';

export default {
    name: "BusDevicesList",
    emits: ['onChange'],
    data() {
        return {
        }
    },
    created() {
        this.$store.dispatch('busDevice/createNewDeviceList', this.slectedController)
       // this.createMajorProducts();
        this.$emit('onChange')
    },
    updated() {
        //this.createMajorProducts()
    },
    methods: {
        saveDevice(device) {
            this.$store.dispatch('busDevice/updateItem', device);
            this.$emit('onChange')
            this.$forceUpdate();
        },
        saveMajorDevice(device) {
            this.$store.dispatch('busDevice/updateMajorItem', device);
            this.$emit('onChange')
            this.$forceUpdate();
        },
        newCardAdded() {
            this.$emit('onChange')
        },
        isChanged() {
            this.$emit('onChange')
        },
        createMajorProducts() {
           // this.$store.dispatch('busDevice/createMajorProducts')
        }
    },
    computed: {
        getControlGearItems() {
            return this.busDevices.filter(obj => obj.typeCategory == 1)
        },
        getInputDeviceItems() {
            return this.busDevices.filter(obj => obj.typeCategory == 3)
        },
        getSensorItems() {
            return this.busDevices.filter(obj => obj.typeCategory == 2)
        },
        ...mapGetters({
            busDevices: 'busDevice/getAllItems',
            majorDeviceItems: 'busDevice/getAllMajorItems',
            controlGearItems: 'busDevice/getControlGearItems',
            inputItems: 'busDevice/getInputItems',
            sensorItems: 'busDevice/getSensorItems',
            productsInDb: 'product/getAll',
            slectedController: 'product/getSelectedApplicationController'
        })

    },
    components: {
        BusDeviceCard,
        BusDeviceCardNew
    },
    props: {
    },
    watch: {
/*         slectedController(newValue, oldValue) {
            if(newValue.systemCategory != oldValue.systemCategory) {
                this.createMajorProducts();
            }
        } */
    }
}
</script>

<style lang="scss" scoped>
</style>